/**
 * Denis Callinan
 * Project Andromeda
 * August 5th, 2020
 * Contact.js - 'Contact' Section
 */

import React from 'react';

// Components
import SectionHeader from '../components/SectionHeader/SectionHeader.js';

export default class Contact extends React.Component {
    handleClick() {
        window.open("https://drive.google.com/file/d/1CEvVFNiaMoFIRz7tmq6W_iVKLGEW-iyk/view?usp=sharing");
    }

    handleEmail() {
        window.location.href = "mailto:drcall04@gmail.com";
    }

    render() {
        return(
            <div className = "page" id = "contact">
                <SectionHeader txt = "white" sectionID = "contact-break" title = "GET IN TOUCH" />
                <p className = "contactText">
                    Interested in getting in contact? You can reach me on my LinkedIn profile found above
                    or send me an e-mail down below. If you want to learn more about me, check out my resume below as well!
                </p>
                <div className = "contactGrid" id = {this.props.state.windowWidth > 950 ? "contact-2": "contact-1"}>
                    <b className  = "contactButton" onClick = {this.handleClick.bind(this)}>Resume</b>
                    <b className  = "contactButton" onClick = {this.handleEmail.bind(this)}>E-mail</b>
                </div>
            </div>
        );
    }
}